import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ColumnMenuViewModel } from '@models/api.models';
import { AccordionClasses } from '@shared/accordion/accordion.config';
import { SortByColumn } from '@features/navigation/mobile/mobile-sub-list/sort-by-column.pipe';
import { TranslateSafePipe } from '../../../../@shared/translate-safe/translate-safe.pipe';
import { SvgIconComponent } from '../../../../@shared/svg-icon/svg-icon.component';
import { AccordionDirective } from '../../../../@shared/accordion/accordion.directive';
import { LinkComponent } from '../../../../@shared/routing/link/link.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-mobile-sub-list',
    templateUrl: './mobile-sub-list.component.html',
    styleUrls: ['./mobile-sub-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, NgIf, LinkComponent, AccordionDirective, SvgIconComponent, TranslateSafePipe, SortByColumn]
})
export class MobileSubListComponent {
    public accordionClasses = AccordionClasses;

    @Input()
    public readonly subLists: ColumnMenuViewModel[];
}
